import axios from "axios";
// const url = process.env.REACT_APP_API_URI;

export const fetchBillingGroupDrop = (data) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/BillingGroup`);
  };

  export const voucher = (data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/IPD/${data?.ipdid}/Voucher`, data);

  };

  export const voucherList = (ipdid) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/IPD/${ipdid}/Vouchers`);

  };


  